import React from "react";




import { Checkbox, Form } from "rsuite";

export default (props) => {
    return <Form.Control
        name={props.name}
        accepter={CheckboxHOC}
        {...props}
    />;
};

const CheckboxHOC = (props) => {
    const onChange = (value, checked) => props.onChange(checked);

    return <Checkbox {...props} onChange={onChange} />;
};